import * as React from 'react';
import { connect } from 'react-redux';
import { Icons, ProductsPage } from '@shared/ui-components';

import { SubscriptionType } from 'common/constants/subscription';
import { SubscriptionsConfig } from 'common/constants/subscription-config';
import { State } from 'common/interfaces/state';
import { MetaTagUtils } from 'common/utils/meta-tag-utils';
import { RedirectUrlUtils } from 'common/utils/redirect-url-utils';
import { Company } from '../account/interfaces/company';
import { ProductLink } from './product-link';


interface ProductConfig {
  name: string;
  id: string;
  url: string;
  color: string;
  videoId?: string;
  additionalInfo?: string;
  image: string;
  Logo: any;
}

interface StateProps {
  companies: Company[];
}


class ProductsPageWrapperComponent extends React.Component<StateProps> {
  public componentDidMount(): void {
    MetaTagUtils.setTitle('Select Product');
  }

  public render(): React.ReactNode {
    const config = this.getProductConfig();
    if (config.length === 1) {
      window.location.replace(config[0].url);
    }
    // const companies = this.props.companies;
    // const hasPlanSubscriptionCompany = companies
    //   && companies.some(x => SubscriptionType.KreoPlan in x.subscriptions);
    // const hasCostEstimateSubscriptionCompany = companies
    //   && companies.some(x => SubscriptionType.KreoPlan in x.subscriptions);

    // const products: ProductConfig[] = [
    //   {
    //     name: '2d takeoff',
    //     id: 'twodtakeoff',
    //     url: 'google.com',
    //     color: '#478fbc',
    //     Logo: Icons.TakeOffIcon,
    //     image: '/static/img/2d_promo_image.jpg',
    //   },
    //   {
    //     name: '3d takeoff',
    //     id: 'threedtakeoff',
    //     url: 'google.com',
    //     color: '#478fbc',
    //     Logo: Icons.TakeOffIcon,
    //     image: 'https://imageskd.s3.eu-west-2.amazonaws.com/product-page/background-modular.png',
    //   },
    // ];

    // if (hasPlanSubscriptionCompany) {
    //   products.push({
    //     name: 'plan',
    //     id: 'plan',
    //     url: 'google.com',
    //     color: '#478fbc',
    //     Logo: Icons.TakeOffIcon,
    //     image: 'https://imageskd.s3.eu-west-2.amazonaws.com/product-page/background-modular.png',
    //   });
    // }

    // if (hasCostEstimateSubscriptionCompany) {
    //   products.push({
    //     name: 'cost estimate',
    //     id: 'costestimate',
    //     url: 'google.com',
    //     color: '#478fbc',
    //     Logo: Icons.TakeOffIcon,
    //     image: 'https://imageskd.s3.eu-west-2.amazonaws.com/product-page/background-modular.png',
    //   });
    // }

    return (
      <ProductsPage
        products={config}
        RouterLink={ProductLink}
        defaultImage='https://imageskd.s3.eu-west-2.amazonaws.com/product-page/background.png'
      />
    );
  }

  private getProductConfig(): ProductConfig[] {
    return Object.entries(SubscriptionsConfig)
      .filter(([_type, conf]) => conf)
      .map(([type, conf]) => {
        return {
          name: conf.name,
          id: conf.id,
          url: RedirectUrlUtils.getRedirectUrl(type as SubscriptionType),
          color: '#478fbc',
          Logo: Icons.TakeOffIcon,
          image: 'https://imageskd.s3.eu-west-2.amazonaws.com/product-page/background-modular.png',
        };
      });
  }
}

function mapStateToProps(state: State): StateProps {
  return {
    companies: state.account.companies,
  };
}

export const ProductsPageWrapper = connect(mapStateToProps)(ProductsPageWrapperComponent);
